export default {
  // Folder colors
  'dashboard.color_indigo': 'Indigo',
  'dashboard.color_purple': 'Purple',
  'dashboard.color_pink': 'Pink',
  'dashboard.color_red': 'Red',
  'dashboard.color_orange': 'Orange',
  'dashboard.color_yellow': 'Yellow',
  'dashboard.color_green': 'Green',
  'dashboard.color_teal': 'Teal',

  // Sidebar
  'dashboard.all_presentations': 'All Presentations',
  'dashboard.new_project': 'New Project',
  'dashboard.projects': 'Projects',
  'dashboard.project_name_placeholder': 'Project name',
  'dashboard.storage': 'Storage',

  // Header
  'dashboard.pdf_upload': 'Upload PDF',
  'dashboard.upload': 'Upload',
  'dashboard.search_placeholder': 'Search files...',

  // Sort options
  'dashboard.sort_date_desc': 'Newest',
  'dashboard.sort_date_asc': 'Oldest',
  'dashboard.sort_name_asc': 'Name A-Z',
  'dashboard.sort_name_desc': 'Name Z-A',
  'dashboard.sort_size_desc': 'Largest',
  'dashboard.sort_size_asc': 'Smallest',

  // Search results
  'dashboard.search_result_count': '{{count}} files found.',

  // Upload area
  'dashboard.uploading': 'Uploading...',
  'dashboard.click_or_drag': 'Click or drag',
  'dashboard.select_file': 'Select File',

  // PDF card
  'dashboard.no_image': 'No image',
  'dashboard.auto_play_on_login': 'Auto-play on login',
  'dashboard.speaker_notes': 'Speaker Notes',
  'dashboard.share': 'Share',
  'dashboard.folder': 'Folder',

  // Delete modal
  'dashboard.delete_file_confirm': 'Delete this file?',
  'dashboard.delete_file_warning': 'Deleted files cannot be recovered.',
  'dashboard.delete_folder_confirm': 'Delete this folder?',
  'dashboard.delete_folder_name': '{{name}} folder will be deleted.',
  'dashboard.delete_folder_warning': 'Presentations inside will be moved to uncategorized.',

  // Empty state
  'dashboard.no_search_results': 'No search results.',
  'dashboard.no_presentations': 'No presentations uploaded.',
  'dashboard.no_presentations_hint': 'Click the upload button above to add a PDF.',

  // QR scan
  'dashboard.qr_scan': 'Scan QR',

  // Alerts
  'dashboard.pdf_only': 'Only PDF files can be uploaded.',
  'dashboard.upload_failed': 'PDF upload failed: {{message}}',
  'dashboard.save_failed': 'PDF info save failed: {{message}}',
  'dashboard.upload_error': 'An error occurred during PDF upload.',
  'dashboard.enter_file_name': 'Please enter a file name.',
  'dashboard.rename_error': 'An error occurred while renaming the file.',
  'dashboard.delete_error': 'An error occurred while deleting the PDF.',
  'dashboard.file_too_large': 'File size exceeds {{limit}}MB limit.',
  'dashboard.storage_exceeded': 'Storage limit exceeded. Free plan allows up to {{limit}}MB.',

  // Folder page
  'dashboard.folder_move': 'Move to Folder',
  'dashboard.current_folder': 'Current folder: {{name}}',
  'dashboard.no_folder': 'No folder assigned',
  'dashboard.select_folder': 'Select Folder',
  'dashboard.new_folder': 'New Folder',
  'dashboard.folder_name_placeholder': 'Folder name',
  'dashboard.unassigned': 'Unassigned',

  // Share page
  'dashboard.share_settings': 'Share Settings',
  'dashboard.share_link': 'Share Link',
  'dashboard.share_link_desc': 'Share your presentation via link',
  'dashboard.password_protection': 'Password Protection',
  'dashboard.password_protection_desc': 'Restrict access with a password',
  'dashboard.new_password_placeholder': 'Enter new password (only to change)',
  'dashboard.enter_password_placeholder': 'Enter password',
  'dashboard.existing_password_hint': 'A password is currently set. Enter a new one to change it.',
  'dashboard.expiry': 'Expiry',
  'dashboard.expiry_desc': 'Set the validity period for the share link',
  'dashboard.expiry_none': 'Unlimited',
  'dashboard.expiry_1h': '1 hour',
  'dashboard.expiry_24h': '24 hours',
  'dashboard.expiry_7d': '7 days',
  'dashboard.expiry_30d': '30 days',
  'dashboard.share_save_error': 'Save failed. Please try again.',

  // Speaker notes page
  'dashboard.speaker_notes_title': 'Speaker Notes',
  'dashboard.page_select': 'Select Page',
  'dashboard.page_number': 'Page {{page}}',
  'dashboard.page_notes': 'Page {{page}} Notes',
  'dashboard.char_count': '{{count}} / 500 characters',
  'dashboard.notes_placeholder': 'Enter speaker notes for this page...',
  'dashboard.notes_tip_title': 'Speaker Notes Tips',
  'dashboard.notes_tip_desc': 'Write notes for each page to reference during your presentation. You can view them on the mobile remote.',
};
